import {extendTheme} from "@chakra-ui/react";

const theme = extendTheme({
    config: {
        initialColorMode: "light",
        useSystemColorMode: false,
    },
    fonts: {
        heading: `'Barlow', system-ui, -apple-system, 'Segoe UI', sans-serif`,
        body: `'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif`,
    },
    colors: {
        // Taken from the logo
        brand: {
            50: "#fbeaed",
            100: "#f3c6cd",
            200: "#e89da9",
            300: "#dc7385",
            400: "#cf4b62",
            500: "#be3045",
            600: "#a2283a",
            700: "#83202f",
            800: "#641824",
            900: "#451118",
        },
        ink: {
            50: "#f6f5f3",
            100: "#ebe9e5",
            200: "#d6d3cd",
            500: "#6b6a67",
            700: "#2b2b2b",
            800: "#1f1f1f",
            900: "#151515",
        },
    },
    styles: {
        global: {
            body: {
                bg: "white",
                color: "ink.800",
            },
        },
    },
    components: {
        Button: {
            baseStyle: {
                borderRadius: "2px",
                fontWeight: 600,
                letterSpacing: "0.06em",
                textTransform: "uppercase",
            },
            defaultProps: {
                colorScheme: "brand",
            },
        },
        Heading: {
            baseStyle: {
                fontWeight: 700,
                color: "ink.900",
            },
        },
        Input: {
            defaultProps: {focusBorderColor: "brand.500"},
        },
        Select: {
            defaultProps: {focusBorderColor: "brand.500"},
        },
        Textarea: {
            defaultProps: {focusBorderColor: "brand.500"},
        },
    },
});

export default theme;
